<template>
    <div class='page'>
      <div class="guide"> 你想要了解你的职业画像，通过职业画像有效的提升自己吗？那么请进行以下操作</div>
      <div class="task_items">
        <div class="task_item" v-for="(item, index) in list" :key="index">
          <span v-if="item.status==0" class="iconfont iconshizhong"></span>
          <van-loading  v-if="item.status==1" color="#1989fa" size='17' style="display: inline" />
          <span v-if="item.status==2" class="iconfont icondui"></span>
          <span v-if="item.status==3" class="iconfont iconcuo"></span>

          <span class="task_item_text">{{item.desc}}</span>
        </div>
      </div>
      <div class="ops">
        <van-button v-if="state==0"  type="info"  block @click="bandExamining" >
          <template v-if="is_have_history">重新检测</template>
          <template  v-else >开始检测</template>
        </van-button>
        <van-button v-if="state==1" type="info"  block  >检测中</van-button>
        <van-button v-if="state==2" type="info"  block @click="bindCreatePortrayal" >去生成画像</van-button>

        <van-button v-if="state==3"  type="info"  block @click="bandExamining" >重新检测</van-button>

        <div class="tips"  v-if="state==3"><span class="iconfont iconkulian1"></span>： 您的信息不全, 未能通过检测，请您登录学生平台，完善【简历】及【职业评测】后，重新评测。</div>
        

        <van-button v-if="is_have_history"  type="info"  block @click="gotoPortrayal" class="history" >查看已测评画像</van-button>
      </div>
    </div>
</template>
<script>
import {Button, Tag, Image as VanImage, Loading, Toast } from 'vant';

export default {
        name: "index",
        components:{
           [Button.name]:Button,
           [Tag.name]:Tag,
           [VanImage.name]:VanImage,
           [Loading.name]:Loading,
           [Toast.name]:Toast,

        },
        data(){
            return {
              state:0, // 0 待检测， 1 正在检测 2：已完成并成功  3：已完成未成功 
              list:[
                {name:"hld",desc:"检测霍兰德职业测评完成情况",  status:0},
                {name:"resume_completion",desc:"检测简历完成度情况",    status:0},
                {name:"professional",desc:"检测学生专业情况",  status:0},
                {name:"expect_job",desc:"检测求职意向完成情况",  status:0},
              ],
              is_have_history:0
            }
        },
        mounted() {
          //this.hasYjyLogin()

        },
        methods:{
          gotoPortrayal(){
            this.$router.push(this.util.urlPrefix+'/portrayal/index?'+'&token='+this.util.token);
          },
          gotoYjyLogin(){
            this.util.tempRedirectUrlSch.set(location.href)
            this.$router.replace(this.util.urlPrefix+'/yjy/login?'+'&token='+this.util.token);
          },
          bindCreatePortrayal(){
            this.getEvaluation()
          },
          bandExamining(){
            this.state = 1
            this.changeStatus(1)

            const _this = this
            setTimeout(function(){
              _this.testEvaluation()
            }, 500)
          },
          changeStatus(status){
            this.list.forEach(function(value){
              value.status = status
            })
          },
          hasYjyLogin(){
            const _this = this
            this.util.server.mini_evaluation.has_yjy_login({
                data:{},
                callback:(res=>{
                    const {code, data, msg} = res
                    if(code==1){
                      if(data.has_login==false){
                         _this.gotoYjyLogin()
                      }else{
                        _this.isHaveHistory()
                      }
                    }
                })
            })
          },
          isHaveHistory(){
            const _this = this
            this.util.server.mini_evaluation.has_evaluation_history({
                data:{},
                callback:(res=>{
                    const {code, data, msg} = res
                    if(code==1){
                      if(data.has_login==true){
                        _this.is_have_history = 1
                      }
                    }
                })
            })
          },
          testEvaluation(){
            const _this = this
            this.util.server.mini_evaluation.test_evaluation({
                data:{},
                is_show_load: false,
                callback:(res=>{
                    const {code, data, msg} = res
                    if(code==1){
                      _this.list.forEach(function(value){
                        // 霍兰德
                        if(value.name == 'hld' ){
                          if(data.hld){
                            value.status = 2
                          }else{
                            value.status = 3
                            _this.state = 3
                          }
                        }

                        if(value.name == 'resume_completion' ){
                          if(data.resume_completion){
                            value.status = 2
                          }else{
                            value.status = 3
                            _this.state = 3
                          }
                        }

                        if(value.name == 'expect_job' ){
                          if(data.expect_job){
                            value.status = 2
                          }else{
                            value.status = 3
                            _this.state = 3
                          }
                        }

                        if(value.name == 'professional' ){
                          value.status = 2
                        }
                        
                      })

                      if(_this.state != 3){
                          _this.state = 2
                      }
                    }
                })
            })
          },
          getEvaluation(){
            const _this = this
            Toast.loading({
              duration: 0,
              message: '画像生成中',
              forbidClick: true
            });
            this.util.server.mini_evaluation.get_evaluation({
                data:{},
                is_show_load: false,
                callback:(res=>{
                  Toast.clear()
                    const {code, data, msg} = res
                    if(code==1){
                      
                      _this.gotoPortrayal()
                    }
                })
            })
          }
        }
          
    }

</script>
<style scoped>
.page{
  padding: 15px;
  box-sizing: border-box;
  background-color: #FFF;
  min-height: 100vh;
}
.guide{
  /* margin-top: 15px; */
  font-size: 14px;
  line-height: 28px;
  text-indent: 16px; 
  color: #5e5d5d;
  font-weight: 600;
}
.task_items{
  margin-top: 20px;
  padding-left: 20px;
}
.task_item{
  height: 35px;
  line-height: 35px;
}
.task_item .iconshizhong{
  color: rgb(209, 127, 20);
}
.task_item .icondui{
  color:rgb(69, 228, 69);
}
.task_item .iconcuo{
  color:red;
}
.task_item_text{
  padding-left: 15px;
  color: #9e9a9a;
}
.ops{
  margin-top: 30px;
}
.history{
  margin-top: 10px;
}
.tips{
  margin-top: 15px;
  color: orange;
  font-size: 13px;
  line-height: 20px;
}
</style>